import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

const sessionReplayTracking = sessionReplayPlugin({
    forceSessionTracking: true,
    sampleRate: 0.1,
});
amplitude.add(sessionReplayTracking);
amplitude.init(import.meta.env.VITE_AMPLITUDE_KEY as string);